<template>
  <div style="width: 100%;">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <a
          v-if="isPasswordForm"
          v-bind="attrs"
          v-on="on"
          class="woo-login-passcode-recovery"
          :style="{
            color: `#${tutorial.passcode_font_color}` || 'black'
          }"
        >Lost the password?</a>
        <v-list-item
          v-else
          class="woo-help-topic"
        >
          <v-list-item-content
            align="left"
            class="woo-help-topic-title"
            v-bind="attrs"
            v-on="on"
          >
            <v-row align="center">
              <v-col align="left" class="woo-help-topic-title-label">
                <v-row class="compact">
                  <v-col class="icon">
                    <v-icon style="color: black;">
                      mdi-human-greeting-variant
                    </v-icon>
                  </v-col>
                  <v-col>
                    Contact us
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        
      </template>

      <v-card>
        <v-app-bar
          flat
          color="rgba(0, 0, 0, 0)"
        >
          <v-toolbar-title class="pl-2" style="font-weight: 900; font-size: 24px;">
            {{isPasswordForm ? 'Lost password?' : 'Contact us'}}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn
            color="black"
            icon
              @click="dialog=false"
            style="margin-right: -8px"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <div v-if="error" class="woo-contact-form">
          <div>Failed to submit ticket!</div>
        </div>
        <div v-else-if="submitted">
          <div class="clip-wrap">
            <div class="clip"/>
            <div class="thanks" :style="{'background-image': 'url(' + require('@/assets/cs.jpg') + ')'}"></div>
          </div>
          <div class="woo-contact-form">
            <div style="text-align: left;">
              <p>Thanks for your message! We'll get back to you as soon as possible.</p>
              <p v-if="!isPasswordForm">Can't wait? Head over to <a href="https://www.thewoobles.com/community">www.thewoobles.com/community</a>
              to ask for help from fellow Wooblers.</p>
            </div>
          </div>
        </div>
        <v-form v-else v-model="valid" class="woo-contact-form">
          <v-text-field
            outlined
            dense
            v-model="name"
            :rules="nameRules"
            label="Name (required)"
            required
          />
          <v-text-field
            outlined
            dense
            v-model="email"
            :rules="emailRules"
            label="E-mail (required)"
            required
          />
          <v-select
            outlined
            dense
            v-model="source"
            style="width: 100%"
            class="woo-select-left-align"
            :items="sources"
            filled
            label="Where did you get the kit?"
            required
          />
          <v-text-field
            outlined
            dense
            v-model="order"
            :label="`Order or Serial Number ${isPasswordForm ? '(required)' : ''}`"
            :required="isPasswordForm"
            :rules="serialRules"
          />
          <v-textarea
            v-if="!isPasswordForm"
            outlined
            dense
            v-model="message"
            :rules="messageRules"
            label="How can we help? (required)"
            rows="3"
            required
          />
          <v-file-input
            multiple
            accept="image/*"
            :label="`${isPasswordForm ? 'Upload kit photo (required)' : 'Upload photo of issue'}`"
            v-model="userFiles"
            :required="isPasswordForm"
            :rules="photoRules"
          />
          <v-btn style="background-color: #000; color: white;" elevation="2" :disabled="!valid || loading" @click="submit" large block>
            <v-icon v-if="loading">mdi-loading</v-icon> SEND
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  
  <div style="width: 100%">
    
  </div>
  </div>
</template>

<script>
import Db from '@/helpers/Db'; 
import api from '@/helpers/api';

export default {
  name: 'ContactForm',
  data() {
    const requiredField = field => v => !!v || `${field} is required`;

    return {
      tutorial: this.$attrs.tutorial,
      isPasswordForm: this.$attrs.isPasswordForm,
      dialog: false,
      loading: false,
      error: false,
      submitted: false,
      valid: false,
      name: '',
      email: '',
      source: null,
      order: '',
      userFiles: [],
      message: '',
      sources: [
        'www.thewoobles.com',
        'Amazon',
        'In a store (JOANN, BLICK, etc)',
        'It was a gift',
        'I don\'t remember',
        'Other',
      ],
      nameRules: [
        requiredField('Name'),
      ],
      emailRules: [
        requiredField('E-mail'),
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      messageRules: [requiredField('Message')],
      serialRules: this.$attrs.isPasswordForm ? [requiredField('Order or Serial')] : [],
      photoRules: [
        requiredField('Kit photo'),
        v => (v && v.length > 0) || 'Kit photo is required',
        v => {
          return !(v ?? []).some(f => f.size > 5e6) || 'Please upload images smaller than 5mb'
        },
      ]
    }
  },
  methods: {
    submit(){
      const { tutorial, step } = this.$attrs;

      const section = Db.findSectionById({
        tutorial,
        sectionId: step?.sectionId,
      });
      
      const meta = {
        name: this.name,
        source: this.source,
        order: this.order,
        // Pre-populated
        tutorialId: tutorial?.id,
        tutorialName: tutorial?.display_name,
        sectionId: section?.id,
        sectionName: section?.display_name,
        stepId: step?.id,
        stepName: step?.display_name,
        path: [tutorial?.display_name, section?.display_name, step?.display_name]
          .filter(Boolean).join(' / '),
      }

      this.loading = true;

      api.createTicket({
        name: this.name,
        email: this.email,
        source: this.source,
        order: this.order,
        userFiles: this.userFiles,
        meta,
        message: this.isPasswordForm ? 'I lost the password' : this.message,
      })
      .then(() => {
        this.submitted = true;
      }).catch(() => {
        this.error = true;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>

.woo-contact-form-header {
  font-weight: bold;
  margin: 10px;
}
.woo-contact-form {
  padding: 24px;
  border-radius: 0.25rem;
  background-color: white;
}

.woo-help-topic {
  background-color: #fff;
  height: 64px;
  border-radius: 0.25rem;
  width: 100%;
}

.woo-help-topic-title-label {
  margin: auto;
  line-height: 1.3rem;
  padding-left: 24px;
  .compact {
    padding: 0;
    .col {
      padding: 0.5rem;
      margin: auto;
    }
    .icon {
      max-width: 2rem;
    }
  }
}

.thanks {
  background-position: center;
  background-size: 180%;
  height: 220px;
  width: 220px;
  margin: auto;
  border: 4px solid #eee;
  border-radius: 50%;
}
</style>